import React from 'react';

import * as Fields from './Fields';
import * as m from '../../messages';
import { TranslatedMessage } from 'common/components/Intl';

const GenderFieldGroup = ({ options }) => {
  return (
    <div className="AddressForm__group">
      <div className="subhead navy AddressForm__group-title">
        <TranslatedMessage id={m.GENDER_TITLE} />
      </div>

      <p className="text flat-blue" />

      <div className="row">
        <div className="col-xs-12">
          <Fields.Gender placeholder={m.GENDER_PLACEHOLDER} options={options} />
        </div>
      </div>
    </div>
  );
};

export default GenderFieldGroup;
